import { Typography } from "antd";

export const LabelledElement = ({ label, type, children }) => {
  const { Text } = Typography;
  const ElementStyle = type === 'inline' ? {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    width: '100%',
  } : {
    width: '100%',
    display: 'block',
  };
  const labelStyle = type !== 'inline' ? {
    marginBottom: '8px',
  } : {};

  const spanStyle = type === 'inline' ? {
    width: '60%',
  } : {};


  return (
    <div style={{ ...ElementStyle, marginBottom: "8px" }}>
      <Text strong style={{ display: "block", ...labelStyle }}>{label}</Text>
      <span style={spanStyle}>{children}</span>
    </div>
  );
}